import { getSourceClick } from '@/lib/marketing/helpers';

function loadGTM(GTM_ID) {
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', GTM_ID);
}

function enqueue(event) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
}

function run() {
  enqueue({
    event: 'default_consent',
    'gtm.consentMode': 'default',
    ad_storage: 'denied',
    analytics_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
  });

  enqueue({
    event: 'consent_update',
    'gtm.consentMode': 'update',
    ad_storage: 'granted',
    analytics_storage: 'granted',
    ad_user_data: 'granted',
    ad_personalization: 'granted',
  });

  const CONTAINERS = {
    'staging.johnsonlawgroup.com': 'GTM-TH633F88',
    'johnsonlawgroup.com': 'GTM-PGKS42BM',
    default: 'GTM-PGKS42BM',
  };

  loadGTM(CONTAINERS[location.host] ?? CONTAINERS['default']);
}

export function pushSessionParams() {
  enqueue({
    session_id: window.JLG?.analytics?.session?.session_id ?? '',
    leadTypeId: window.JLG?.marketing?.lead_type?.id ?? 0,
    leadTypeName: window.JLG?.marketing?.lead_type?.name ?? '',
    cid: window.JLG?.marketing?.campaign?.id ?? 0,
    oid: window.JLG?.marketing?.offer?.id ?? 0,
    lead_source: window.JLG?.marketing?.lead_source?.type?.name ?? 'Unknown',
    version: '2',
    ...getSourceClick(),
  });
}

export { run, enqueue };
